import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { isDraftValid } from '../domain/password-change.validation';

const selectPasswordChange = (state: RootState) => state.passwordChange;

export const selectIsOpen = (state: RootState) => selectPasswordChange(state).open;
export const selectDraft = (state: RootState) => selectPasswordChange(state).draft;
export const selectSubmitStatus = (state: RootState) => selectPasswordChange(state).submitStatus;
export const selectError = (state: RootState) => selectPasswordChange(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectPasswordChange(state).validationErrors;
export const selectRevokedSessions = (state: RootState) =>
  selectPasswordChange(state).revokedSessions;

export const selectIsSubmitting = (state: RootState) =>
  selectPasswordChange(state).submitStatus === 'submitting';

/** Derived: can the form be submitted? Memoised on the draft reference. */
export const selectCanSubmit = createSelector(selectDraft, isDraftValid);
